"use client";

import { Splash } from "@/components/Splash/Splash";
import { useTheme } from "@/hooks/useTheme";
import { Button } from "@cloudspire/shared/components/ui/button";
import { Flex } from "@cloudspire/shared/components/ui/flex";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import { useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export function Maintenance() {
  const intl = useIntl();

  const { theme } = useTheme();

  const { nextjsAccountRouter } = useRouters();

  const handleClick = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Flex
      flexDirection="column"
      h="100dvh"
      justifyContent="center"
      px="16px"
      py="32px"
    >
      <Splash
        title={intl.formatMessage({ defaultMessage: "Site en maintenance" })}
        description={intl.formatMessage({
          defaultMessage:
            "Votre espace privé est en cours de maintenance, merci de revenir plus tard.",
        })}
        src={nextjsAccountRouter.getUrl({
          id: "@account-v2/assets",
          parameters: { resource: `/assets/splashes/maintenance/${theme}.svg` },
        })}
      >
        <Button colorPalette="primary" size="md" onClick={handleClick}>
          <FormattedMessage defaultMessage="Recharger la page" />
        </Button>
      </Splash>
    </Flex>
  );
}
